<template>
    <h2 class="heading">Printing / Procurement Form</h2>
    <div class="form">
        <el-form :model="procurement" label-width="120px" style="width:1200px" >
            <el-form-item label="Category" required>
                <el-select v-model="procurement.category" style="width:220px;" placeholder="Select category" @change="changeCategory">
                    <el-option label="Printing" value="printing"/>
                    <el-option label="Procurement" value="procurement"/>
                </el-select>
            </el-form-item>
            <el-form-item label="Purpose" required>
                <el-input v-model="procurement.purpose" minlength="2" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Requester" required>
                <el-select v-if="global.hasRight('printing-procurement', 'statistician')" v-model="procurement.requester" placeholder="Select User">
                    <el-option v-for="user in allUsers" :key="user.id" :label="user.fullname" :value="user.loginname"/>
                </el-select>
                <el-input v-else v-model="currentUser.fullname" readonly="true" style="width:220px; background-color:#ffe !important;"/>
            </el-form-item>
            <el-form-item label="Need by date" required>
                <el-date-picker v-model="procurement.needDate" type="date" placeholder="Need by date" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>

            <el-form-item label="Printing" required v-if="procurement.category == 'printing'">
                <table class="item">
                    <tr>
                        <th>Item Name</th>
                        <th>Type</th>
                        <th>Size</th>
                        <th class="center">Quantity</th>
                        <th class="center">Pages</th>
                        <th class="right">Costs</th>
                        <th class="center">Attachments</th>
                        <th class="center">Action</th>
                    </tr>
                    <tr v-for="(item, index) in printItems" :key="index">
                        <td><el-input v-model="item.itemName" maxlength="50" placeholder="Item Name" style="width:200px;"/></td>
                        <td><el-select v-model="item.printType" placeholder="Type" style="width:80px;">
                                <el-option label="b&amp;w" value="b&amp;w"/>
                                <el-option label="color" value="color"/>
                            </el-select>
                        </td>
                        <td><el-select v-model="item.printSize" placeholder="Size" style="width:80px;">
                                <el-option label="A3" value="A3"/>
                                <el-option label="A4" value="A4"/>
                                <el-option label="A5" value="A5"/>
                            </el-select>
                        </td>
                        <td class="center"><el-input-number v-model="item.printQty" :min="0" :max="10000" precision="0" style="width:130px;"  /></td>
                        <td class="center"><el-input-number v-model="item.pages" :min="0" :max="1000" precision="0" style="width:130px;"/></td>
                        <td class="right amount">{{printCosts[index]}}</td>
                        <td style="text-align:center;min-width:240px;">
                            <el-tag v-if="item.attachments != null" closable @close="removeFile(index)">
                                <a href="" @click.prevent="global.down(item.attachments.url, item.attachments.origName)">{{item.attachments.origName}}</a>
                            </el-tag>
                            <el-upload :action="global.upload_path" :limit="1" @change="setIndex(index)"
                                    :on-success="uploaded" :data="{'type':'procurement'}" :show-file-list="false">
                                <el-button type="primary" plain>Browse</el-button>
                            </el-upload>
                        </td>
                        <th class="center">
                            <el-icon v-if="index == 0" title="Add printing item" @click="addPrintItem" size="28"><Plus/></el-icon>
                            <el-icon v-else title="Remove" @click="printItems.splice(index, 1)" size="28"><Minus/></el-icon>
                        </th>
                    </tr>
                </table>
            </el-form-item>
            <el-form-item label="Procurement" required v-if="procurement.category == 'procurement'">
                <table class="item">
                    <tr>
                        <th>Goods Name</th>
                        <th class="center">Quantity</th>
                        <th class="center">Unit Price</th>
                        <th class="center">Currency</th>
                        <th class="center">Amount</th>
                        <th class="center">Attachments</th>
                        <th class="center">Action</th>
                    </tr>
                    <tr v-for="(item, index) in procureItems" :key="index">
                        <td><el-input v-model="item.goodsName" maxlength="50" placeholder="Goods Name" style="width:200px;"/></td>
                        <td class="center"><el-input-number v-model="item.procureQty" :min="0" :max="1000" precision="1" style="width:200px;"  /></td>
                        <td class="center"><el-input-number v-model="item.unitPrice" :min="0" :max="100000" precision="2" style="width:200px;"/></td>
                        <td class="center">
                            <el-select v-if="index==0" v-model="item.currency" placeholder="Currency" style="width:80px;">
                                <el-option v-for="item in currencies" :key="item" :label="item" :value="item"/>
                            </el-select>
                            <el-input v-else v-model="item.currency" placeholder="Currency" readonly style="width:80px;"/>
                        </td>
                        <td class="center amount">{{procureCosts[index]}}</td>
                        <td style="text-align:center;min-width:240px;">
                            <el-tag v-if="item.attachments != null" closable @close="removeFile(index)">
                                <a href="" @click.prevent="global.down(item.attachments.url, item.attachments.origName)">{{item.attachments.origName}}</a>
                            </el-tag>
                            <el-upload :action="global.upload_path" :limit="1" @change="setIndex(index)"
                                    :on-success="uploaded" :data="{'type':'procurement'}" :show-file-list="false" >
                                <el-button type="primary" plain>Browse</el-button>
                            </el-upload>
                        </td>
                        <th class="center">
                            <el-icon v-if="index == 0" title="Add procurement item" @click="addProcureItem" size="28"><Plus/></el-icon>
                            <el-icon v-else title="Remove" @click="procureItems.splice(index, 1)" size="28"><Minus/></el-icon>
                        </th>
                    </tr>
                </table>
            </el-form-item>
            <el-form-item label="Expense" required>
                <span class="amount">{{expense}} {{procureItems[0].currency}}</span>
            </el-form-item>
            <el-form-item label="Remarks">
                <el-input v-model="procurement.remarks" type="textarea" maxlength="500" show-word-limit="true"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="saveProcurement">Submit</el-button>
                <el-button @click="$router.push('/procurement/myProcurementList')">Cancel</el-button>
                <span class="errMsg" v-html="errMsg" v-if="errMsg != ''"></span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Plus, Minus } from '@element-plus/icons-vue'
export default {
    components: {
        Plus, Minus
    },
    data() {
        return {
            procurement: {
                uuid: null,
                requester: null,
                purpose: '',
                needDate: null,
                category: 'printing',
                printItems: "",
                procureItems: "",
                remarks: '',
            },
            printItems: [{
                itemName: '',
                printType: null,
                printSize: null,
                pages: 0,
                printQty: 0,
                costs: 0.0,
                attachments: null
            }],
            procureItems: [{
                goodsName: '',
                procureQty: 0.0,
                unitPrice: 0.0,
                currency: 'HKD',
                costs: 0.0,
                attachments: null
            }],
            allUsers: [],
            currencies: ['HKD', 'USD', 'CNY', 'CNH', 'GBP', 'EUR', 'TWD', 'SGD', 'JPY'],
            currentUser: null,
            errMsg: '',
            index: -1,
            global,
            loading: false,
        }
    },
    async created() {
        this.global.index = "procurement";
        this.currentUser = this.global.currentUser;
        this.procurement.requester = this.currentUser.loginname;
        if (this.global.hasRight('printing-procurement', 'statistician')) {
            this.allUsers = await this.global.getAllUsers();
        }
    },
    computed: {
        printCosts() {
            let costs = new Array();
            for (var i = 0; i < this.printItems.length; i++) {
                var price = 0.0;
                if (this.printItems[i].printType == "b&w")
                    price = 0.6;
                else if (this.printItems[i].printType == "color")
                    price = 1.0;
                if (this.printItems[i].printSize == "A5")
                    price = price * 0.5;
                else if (this.printItems[i].printSize == "A3")
                    price = price * 2;
                var cost = price * this.printItems[i].pages * this.printItems[i].printQty;
                costs.push(cost.toFixed(2));
            }
            return costs;
        },
        procureCosts() {
            let costs = new Array();
            for (let item of this.procureItems) {
                var cost = item.procureQty * item.unitPrice;
                costs.push(cost.toFixed(2));
            }
            return costs;
        },
        expense() {
            let costs = this.procurement.category == 'printing' ? this.printCosts : this.procureCosts;
            let total = 0.0;
            for (let cost of costs) 
                total += parseFloat(cost);
            return total.toFixed(2);
        }
    },
    async mounted() {
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/procurement/procurementDetail", {code: code});
            if (result.success) {
                this.procurement = result.data.procure;
                this.printItems = result.data.printItems;
                this.procureItems = result.data.procureItems;
            }
        }
    },
    methods: {
        uploaded(response, file, uploadFiles) {
            let attachments = {};
            let i = this.index;
            let resp = uploadFiles[0].response[0];
            if (resp) {
                attachments.origName = resp.name;
                attachments.url = resp.url;
                attachments.fileType = attachments.url.substring(attachments.url.lastIndexOf("."));
                if (this.procurement.category == 'printing') {
                    this.printItems[i].attachments = attachments;
                } else {
                    this.procureItems[i].attachments = attachments;
                }
                uploadFiles.splice(0, uploadFiles.length); //clear all elements of uploadFiles 
            }
            this.index = -1;
        },
        setIndex(index) {
            this.index = index;
            return true;
        },
        removeFile(index) {
            if (this.procurement.category == 'printing') {
                this.printItems[index].attachments = null;
            } else {
                this.procureItems[index].attachments = null;
            }
        },
        addPrintItem() {
            this.printItems.push({
                itemName: '', printType: null, printSize: null, pages: 0.0, printQty: 0.0, costs: 0.0, files: null
            });
        },
        addProcureItem() {
            let currency = this.procureItems.length == 0 ? "HKD" : this.procureItems[0].currency;
            this.procureItems.push({
                goodsName: '', procureQty: 0.0, unitPrice: 0.0, costs: 0.0, currency: currency, files: null
            });
        },
        checkCurrency(el) {
            let firstCurrency = this.procureItems.length == 0 ? "HKD" : this.procureItems[0].currency;
            if (firstCurrency != el.currency) {
                this.errMsg = "Please input [purpose]"; 
                return false;
            }
        },
        async saveProcurement() {
            this.errMsg = "";
            if (this.procurement.purpose == null || this.procurement.purpose == '') {
                this.errMsg = "Please input [purpose]"; return;
            }
            if (this.procurement.needDate == null || this.procurement.needDate == '') {
                this.errMsg = "Please choose [Need by date]"; return;
            }
            if (this.procurement.category == 'printing') {
                let i = 0;
                for (let item of this.printItems) {
                    if (item.itemName == '' || item.itemName == null) {
                        this.errMsg = "Please input [Item name]"; return;
                    }
                    if (item.printType == null) {
                        this.errMsg = "Please choose [Type]"; return;
                    }
                    if (item.printSize == null) {
                        this.errMsg = "Please choose [Size]"; return;
                    }
                    if (item.printQty == 0) {
                        this.errMsg = "Please input [Quantity]"; return;
                    }
                    if (item.pages == 0) {
                        this.errMsg = "Please input [Pages]"; return;
                    }
                    item.costs = this.printCosts[i++];
                }
                this.procurement.printItems = JSON.stringify(this.printItems);
            } else {
                let i = 0;
                for (let item of this.procureItems) {
                    if (item.goodsName == '' || item.goodsName == null) {
                        this.errMsg = "Please input [Goods Name]"; return;
                    }
                    if (item.procureQty == 0.0) {
                        this.errMsg = "Please input [Quantity]"; return;
                    }
                    item.costs = this.procureCosts[i++];
                    console.log(item.currency);
                }
                this.procurement.procureItems = JSON.stringify(this.procureItems);
                console.log(this.procurement.procureItems);
            }
            
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/procurement/saveProcurement", this.procurement);
            if (result.success) {
                this.$router.push("/procurement/myProcurementList");
            }
        }
    }
}
</script>

<style scoped>
    .heading { width:1100px; }
</style>